import BalanceAlert from './balance-alert';
export default BalanceAlert;
